<template>
  <div class="customcheckerboard-top-nav">
    <div slot="top-left">
      <button
        type="button"
        v-show="isBackButtonVisible"
        :class="[
          'customcheckerboard-top-nav-back',
          {'customcheckerboard-top-nav-back-text': isBackButtonAsText},
          { disabled: !enableControls }
        ]"
        title="Back"
        @click="goBack"
      >
        <span v-if="isBackButtonAsText">{{ translations.vctBackButtonAsText }}</span>
        <span v-else class="icon-arrow-left-indicator-open"></span>
      </button>
    </div>
    <div class="customcheckerboard-top-nav-center">
      <div class="customcheckerboard-top-nav-logo">
        <img :src="`${assetsPath}/images/common/customs_logo_red.png`" alt/>
      </div>
      <div>
        <h2 class="customcheckerboard-top-nav-title">{{ translations.customChekerboardTitle }}</h2>
      </div>
    </div>
    <div slot="top-right">
      <button
        type="button"
        :class="[
          'customcheckerboard-top-nav-close',
          { disabled: !enableControls }
        ]"
        title="Close"
        @click="exit"
      >
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "customcheckerboardTopNav",
  props: {
    isMainApp: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    assetsPath() {
      return this.$store.state.endPoints.customcheckerboard.customsAssets;
    },
    isBackButtonVisible() {
      const { navigation } = this.$store.state.customCheckerboard;
      return navigation.activeViewIndex > 0 || this.isMainApp;
    },
    enableControls() {
      return this.$store.state.customCheckerboard.enableControls;
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    isBackButtonAsText() {
      return this.$store.state.utils.configuration.vct_settings && this.$store.state.utils.configuration.vct_settings.custom_checkerboard.back_button_as_text;
    }
  },
  methods: {
    goBack() {
      if (!this.enableControls) return;
      if (this.useEcomDataLayerFormat) {
        this.$checkerboardDataLayer.logAnalyticsEvent({eventLabel: this.$checkerboardDataLayer.labels.backModal});
      }
      if (this.$store.state.customCheckerboard.navigation.activeViewIndex === 0) {
        this.exit();
      } else {
        this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", false);
        this.$eventBus.$emit("customcheckerboard-go-to-previous-step");
      }
    },
    exit() {
      if (!this.enableControls) return;
      if (this.useEcomDataLayerFormat) {
        this.$checkerboardDataLayer.logAnalyticsEvent({eventLabel: this.$checkerboardDataLayer.labels.closeModal});
      }
      this.$eventBus.$emit("customcheckerboard-exit");
      if (this.$store.state.utils.configuration.enableCheckerboardExitAlert) {
        if (this.translations.customCheckerboardExitAlertMessage) {
          this.$eventBus.$emit("customcheckerboard-exit");
        }
      } else {
        this.$eventBus.$emit("customcheckerboard-exit");
      }
    },
  }
};
</script>
